import { EventPaginationParams, FetchEventRepository } from '@/module/event/data/repository/fetch_event_repository';
import { en } from "../model/event";
import { EventPagination } from '../model/event_pagination';

type FetchEventsParams = {
  ownerType: string
  ownerID?: number
  startDate?: string
  endDate?: string
  page: number
  itemsPerPage?: number
}

export interface FetchEventsUseCase {
  (params: FetchEventsParams): Promise<EventPagination | undefined>
}

const fetchEventsUseCase = (repository: FetchEventRepository): FetchEventsUseCase => async (params: FetchEventsParams) => {
  const { ownerID, ownerType, page, startDate, endDate, itemsPerPage } = params

  const payload: EventPaginationParams = {
    descending: "true",
    eventType: "",
    itemsPerPage: itemsPerPage ?? 20,
    ownerID,
    ownerType,
    page,
    sort: en.created_date.toString(),
    startDate,
    endDate,
  }

  return await repository(payload);
}

export default fetchEventsUseCase;
